import { useNavigate, useParams } from 'react-router-dom';
import { baseErrorHandler } from '@queries/baseErrorHandler';
import { showMessage } from '@queries/showMessage';
import { $api } from '@service/RequestService';
import { useMutation, useQueryClient } from 'react-query';

import { clientConstants, useAction } from '..';

export const useClientExterminate = (props?: { onSuccess: () => void }) => {
  const params = useParams();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const { exterminate } = useAction();

  return useMutation(
    async (id: number) => {
      const res = await $api.delete(`/v1/client/${exterminate?.isDelete ? 'delete' : 'exterminate'}/${id}`);

      return res.data;
    },
    {
      onSuccess: async res => {
        await qc.invalidateQueries([clientConstants.queryKeys.CLIENT]);

        if (props?.onSuccess) {
          props?.onSuccess();
        }

        if (params?.idClient) {
          navigate(-1);
        }

        showMessage(res?.message, true);
      },
      onError: err => {
        baseErrorHandler(err);

        if (props?.onSuccess) {
          props?.onSuccess();
        }
      }
    }
  );
};
